// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start; /* Alinea los elementos al principio */
    margin-bottom: 20px;
}

.upload-container {
    display: flex;
    gap: 10px; /* Espaciado entre los botones */
}

.pedido-details {
    flex-grow: 1; /* Permite que ocupe el espacio necesario */
    display: flex;
    justify-content: flex-end; /* Alinea los detalles hacia la derecha */
}

.pedido-card {
    max-width: 300px;
    text-align: left;
    padding: 10px;
    background-color: #f8f9fa; /* Fondo claro para destacar */
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.pedido-details-horizontal {
    display: flex;
    justify-content: space-between;
    align-items: center; /* Alinea los elementos verticalmente */
    padding: 10px 15px;
    margin-bottom: 20px;
    background-color: #f8f9fa; /* Fondo claro */
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    flex-wrap: wrap; /* Permite que se ajusten en pantallas pequeñas */
}

.pedido-info {
    margin-right: 20px; /* Espaciado entre los bloques de información */
    text-align: left;
    font-size: 14px;
}

.tipos-mcia-list {
    margin: 0;
    padding: 0;
    list-style-type: none; /* Sin viñetas para la lista */
}

.tipos-mcia-list li {
    display: inline;
    margin-right: 10px; /* Espacio entre elementos */
}
`, "",{"version":3,"sources":["webpack://./src/styles/CargarListaDeEmpaqueModal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB,EAAE,sCAAsC;IAC/D,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS,EAAE,gCAAgC;AAC/C;;AAEA;IACI,YAAY,EAAE,2CAA2C;IACzD,aAAa;IACb,yBAAyB,EAAE,yCAAyC;AACxE;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,yBAAyB,EAAE,8BAA8B;IACzD,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB,EAAE,uCAAuC;IAC5D,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB,EAAE,gBAAgB;IAC3C,kBAAkB;IAClB,wCAAwC;IACxC,eAAe,EAAE,iDAAiD;AACtE;;AAEA;IACI,kBAAkB,EAAE,+CAA+C;IACnE,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,qBAAqB,EAAE,8BAA8B;AACzD;;AAEA;IACI,eAAe;IACf,kBAAkB,EAAE,4BAA4B;AACpD","sourcesContent":[".header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start; /* Alinea los elementos al principio */\n    margin-bottom: 20px;\n}\n\n.upload-container {\n    display: flex;\n    gap: 10px; /* Espaciado entre los botones */\n}\n\n.pedido-details {\n    flex-grow: 1; /* Permite que ocupe el espacio necesario */\n    display: flex;\n    justify-content: flex-end; /* Alinea los detalles hacia la derecha */\n}\n\n.pedido-card {\n    max-width: 300px;\n    text-align: left;\n    padding: 10px;\n    background-color: #f8f9fa; /* Fondo claro para destacar */\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.pedido-details-horizontal {\n    display: flex;\n    justify-content: space-between;\n    align-items: center; /* Alinea los elementos verticalmente */\n    padding: 10px 15px;\n    margin-bottom: 20px;\n    background-color: #f8f9fa; /* Fondo claro */\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    flex-wrap: wrap; /* Permite que se ajusten en pantallas pequeñas */\n}\n\n.pedido-info {\n    margin-right: 20px; /* Espaciado entre los bloques de información */\n    text-align: left;\n    font-size: 14px;\n}\n\n.tipos-mcia-list {\n    margin: 0;\n    padding: 0;\n    list-style-type: none; /* Sin viñetas para la lista */\n}\n\n.tipos-mcia-list li {\n    display: inline;\n    margin-right: 10px; /* Espacio entre elementos */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
